module.exports = __webpack_public_path__ + "static/media/heart_hollow.498c24b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/statistics/heart_hollow.svg
// module id = 277
// module chunks = 0